import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import find from 'lodash/find'
import times from 'lodash/times'
import constant from 'lodash/constant'
import { Checkbox, Grid } from 'semantic-ui-react'
import { formValueSelector } from 'redux-form'
import { LKDate } from 'loankeeper-common/helpers/Date'

// @ts-ignore
import LKButton from 'shared/LKButton'
// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'
// @ts-ignore
import { GridContainer } from 'shared/StyledComponents'
// @ts-ignore
import LKDropdownButton from 'shared/LKDropdownButton'
// @ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'

import { withSystemConfig } from 'shared'
import { convertUnicodeToLatin } from '../../../../../store/utility'
import { loadCRAData } from '../../../../../store/cra'
import { handlePreventAction, isRequired, normalizeCardNumber } from '../../../helpers'
import { FORM_NAME } from '../../../constants'
import translate from '../../translate'

import container from './container'
import { focusStateTypes } from 'src/features/ClientForm/models/focus-state.constant'

const StyledDatePicker = styled(FormField)`
  position: relative;

  .DayPickerInput-Overlay {
    position: absolute;
    top: -33px;
    transform: translate(0, -100%);
  }
`

const selector = formValueSelector(FORM_NAME)

@withSystemConfig(['SDACRAConfig as craConfig'])
@(connect(
  (state) => {
    const { CardNumber, IND_DOB, OtherIDNumber } = selector(state, 'CardNumber', 'IND_DOB', 'OtherIDNumber')
    return {
      CardNumber,
      IND_DOB,
      OtherIDNumber,
    }
  },
  {
    openError: LKModalActions.openError,
    convertUnicodeToLatin,
    loadCRAData,
  },
) as any)
class IdentityInformation extends React.Component<any> {
  state = {
    ShowIDValidityDate: true,
    cardNumberFocusState: focusStateTypes.NONE,
    otherIDNumberFocusState: focusStateTypes.NONE,
  }

  handleCardNumberInputFocus = () => {
    this.setState({ cardNumberFocusState: focusStateTypes.PRIMARY })
  }

  handleCardNumberInputBlur = () => {
    this.setState({ cardNumberFocusState: focusStateTypes.NONE })
  }

  handleCardNumberAltInputFocus = () => {
    this.setState({ cardNumberFocusState: focusStateTypes.SECONDARY })
  }

  handleOtherIDNumberInputFocus = () => {
    this.setState({ otherIDNumberFocusState: focusStateTypes.PRIMARY })
  }

  handleOtherIDNumberInputBlur = () => {
    this.setState({ otherIDNumberFocusState: focusStateTypes.NONE })
  }

  handleOtherIDNumberAltInputFocus = () => {
    this.setState({ otherIDNumberFocusState: focusStateTypes.SECONDARY })
  }

  onSelectIDCardType = ({ DFCitizID, DFResidID }) => {
    this.props.changeCitizenshipID(DFCitizID)
    this.props.changeResidentID(DFResidID)
  }

  handleShowIDValidityDateChange = (_, { checked }) => {
    this.setState({ ShowIDValidityDate: checked })

    if (!checked) {
      this.props.deleteValidityDate()
    }
  }

  handleIDCardTypeChange = (event, selectedId) => {
    const selected = find(this.props.selects.IDCardtype, (i) => i.ID === selectedId)

    if (selected) {
      this.onSelectIDCardType(selected)
    }
  }

  formatHiddenValue = (value) => times(value.toString().length, constant('*')).join('')

  isCRAConfigEmpty = () => Array.isArray(this.props.craConfig) && this.props.craConfig.length > 0

  handleCRAOptionChange = async (event, data) => {
    const { CardNumber, IND_DOB, OtherIDNumber, onChangeCRAImage, changeFormValue: change } = this.props

    const [year] = IND_DOB.split('.').reverse()

    const result = await this.props.loadCRAData({
      pin: CardNumber,
      idDocNo: OtherIDNumber,
      birthYear: year,
      subContractId: data.value,
    })

    if (loadCRAData.fulfilled.match(result)) {
      const {
        profile: {
          Photo_PhotoImage,
          Person_FirstName,
          Person_LastName,
          Person_CitizenshipCountry,
          PrivateNumber,
          Number,
          Person_BirthDate,
          Document_DocTypeName,
          Document_IssueDate,
          Registration_ActiveAddress,
        },
      } = result.payload

      onChangeCRAImage(Photo_PhotoImage, async () => {
        change('CardNumber', PrivateNumber)
        change('CardNumberAlt', PrivateNumber)
        change('OtherIDNumber', Number)
        change('OtherIDNumberAlt', Number)

        const cardType = find(this.props.selects.IDCardtype, ['Title', Document_DocTypeName])
        if (cardType) {
          change('IDCardTypeID', Document_DocTypeName)
        } else if (!this.props.IDCardIssuerTxt) {
          change('IDCardIssuerTxt', Document_DocTypeName)
        } else {
          change('IDCardTypeID', 6)
        }

        const [lastNameConvertResult, firstNameConvertResult] = await Promise.all([
          this.props.convertUnicodeToLatin(Person_LastName),
          this.props.convertUnicodeToLatin(Person_FirstName),
        ])

        if (convertUnicodeToLatin.fulfilled.match(lastNameConvertResult)) {
          change('IND_Surname_ALT', lastNameConvertResult.payload)
        }

        if (convertUnicodeToLatin.fulfilled.match(firstNameConvertResult)) {
          change('IND_Name_ALT', firstNameConvertResult.payload)
        }

        change('IDCardRegDate', LKDate.from(Document_IssueDate).toString())
        change('IND_Surname', Person_LastName)
        change('IND_Name', Person_FirstName)
        change('IND_DOB', LKDate.from(Person_BirthDate).toString())

        const citizenship = find(this.props.selects.Citizenship, ['Title', Person_CitizenshipCountry])
        if (citizenship) {
          change('CitizenshipID', citizenship.ID)
        }

        const addressRaw = Registration_ActiveAddress ? Registration_ActiveAddress.replace('საქართველო, ', '') : ''

        const addressParts = addressRaw.split(', ')
        if (addressParts.length) {
          const cityName = addressParts[0].replace('ქალაქი ', '')
          const city = find(this.props.selects.City, ['Title', cityName])
          if (city) {
            change('City', city.ID)
          }
        }

        if (addressParts.length > 1) {
          addressParts.shift()
          const address = addressParts.join(', ')
          change('Address', address)

          const addressConvertResult = await this.props.convertUnicodeToLatin(address)
          if (convertUnicodeToLatin.fulfilled.match(addressConvertResult)) {
            change('Address_ALT', addressConvertResult.payload)
          }
        }
      })
    }
  }

  getCardNumberInputType = (NumField: 0 | 1) => {
    if (NumField === 0) return 'text'
    if (NumField === 1) return 'number'
  }

  render() {
    const { fields, selects, noVisibilityFilter, actionType, permissions, IDCardTypeID, craConfig, CRAImage } =
      this.props
    const { ShowIDValidityDate, cardNumberFocusState, otherIDNumberFocusState } = this.state
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ width: '100%' }}>
          {(!!fields.IDCardTypeID || !!fields.IDCardIssuerID) && (
            <FormLayout
              visible={noVisibilityFilter || !!(fields.IDCardTypeID || fields.IDCardIssuerID)}
              label={translate('lbl_id_Card_Type')}
              labelFieldProportions="5:11"
            >
              {!!fields.IDCardTypeID && (
                <FormField
                  visible={noVisibilityFilter || !!fields.IDCardTypeID}
                  name="IDCardTypeID"
                  options={selects.IDCardtype}
                  required={isRequired(fields.IDCardTypeID)}
                  onChange={this.handleIDCardTypeChange}
                  search
                  type="select"
                />
              )}
              {!!fields.IDCardIssuerID && (
                <FormField
                  visible={noVisibilityFilter || !!fields.IDCardIssuerID}
                  name="IDCardIssuerID"
                  options={selects.Cardissuer}
                  required={isRequired(fields.IDCardIssuerID)}
                  search
                  type="select"
                />
              )}
            </FormLayout>
          )}
          {!!fields.IDCardIssuerTxt && (
            <FormLayout
              visible={noVisibilityFilter || !!fields.IDCardIssuerTxt}
              label={translate('lbl_idcardissuer_txt')}
              labelFieldProportions="5:11"
            >
              <FormField
                visible={noVisibilityFilter || !!fields.IDCardIssuerTxt}
                name="IDCardIssuerTxt"
                required={isRequired(fields.IDCardIssuerTxt)}
                type="text"
              />
            </FormLayout>
          )}

          {(!!fields.CardNumber || !!fields.OtherIDNumber) && (
            <FormLayout
              visible={noVisibilityFilter || !!fields.CardNumber}
              label={translate('lbl_ID_number')}
              labelFieldProportions="5:11"
            >
              {!!fields.CardNumber && (
                <FormField
                  visible={noVisibilityFilter || !!fields.CardNumber}
                  name="CardNumber"
                  dontParseToInt
                  disabled={
                    actionType === 'edit' &&
                    (!permissions.VIEW_CLIENT || !permissions.EDIT_CLIENT || !permissions.EDIT_CLIENT_ID)
                  }
                  type={
                    selects.IDCardtype[IDCardTypeID - 1] && selects.IDCardtype[IDCardTypeID - 1].ID === 6
                      ? 'text'
                      : this.getCardNumberInputType(fields.CardNumber.NumField)
                  }
                  flags={{ symbolCounter: true }}
                  required={isRequired(fields.CardNumber)}
                  maxLength={
                    selects.IDCardtype[IDCardTypeID - 1] && selects.IDCardtype[IDCardTypeID - 1].ID === 6
                      ? undefined
                      : fields.CardNumber && fields.CardNumber.MaxLen
                  }
                  minLength={fields.CardNumber.MinLen}
                  normalize={normalizeCardNumber(
                    'IDCardTypeID',
                    fields.CardNumber.NumField,
                    selects.IDCardtype[IDCardTypeID - 1] && selects.IDCardtype[IDCardTypeID - 1].ID,
                  )}
                  onFocus={this.handleCardNumberInputFocus}
                  onCopy={handlePreventAction}
                  onCut={handlePreventAction}
                  onPaste={handlePreventAction}
                  onDrag={handlePreventAction}
                  onDrop={handlePreventAction}
                  onBlur={this.handleCardNumberInputBlur}
                  onChange={this.props.clearCellPhoneValidateCode}
                  format={cardNumberFocusState === focusStateTypes.SECONDARY ? this.formatHiddenValue : undefined}
                  isPersonalNo
                />
              )}
              {!!fields.OtherIDNumber && (
                <FormField
                  visible={noVisibilityFilter || !!fields.OtherIDNumber}
                  name="OtherIDNumber"
                  required={isRequired(fields.OtherIDNumber)}
                  type="text"
                  onFocus={this.handleOtherIDNumberInputFocus}
                  onCopy={handlePreventAction}
                  onCut={handlePreventAction}
                  onPaste={handlePreventAction}
                  onDrag={handlePreventAction}
                  onDrop={handlePreventAction}
                  onBlur={this.handleOtherIDNumberInputBlur}
                  onChange={this.props.clearCellPhoneValidateCode}
                  format={otherIDNumberFocusState === focusStateTypes.SECONDARY ? this.formatHiddenValue : undefined}
                  maxLength={fields.OtherIDNumber ? fields.OtherIDNumber.MaxLen : -1}
                  labelFieldProportions="5:11"
                />
              )}
            </FormLayout>
          )}

          {(!!fields.CardNumber || !!fields.OtherIDNumber) && (
            <FormLayout visible={noVisibilityFilter || !!fields.CardNumber} label=" " labelFieldProportions="5:11">
              {!!fields.CardNumber && (
                <FormField
                  visible={noVisibilityFilter || !!fields.CardNumber}
                  name="CardNumberAlt"
                  dontParseToInt
                  disabled={
                    actionType === 'edit' &&
                    (!permissions.VIEW_CLIENT || !permissions.EDIT_CLIENT || !permissions.EDIT_CLIENT_ID)
                  }
                  type={
                    selects.IDCardtype[IDCardTypeID - 1] && selects.IDCardtype[IDCardTypeID - 1].ID === 6
                      ? 'text'
                      : this.getCardNumberInputType(fields.CardNumber.NumField)
                  }
                  flags={{ symbolCounter: true }}
                  required={isRequired(fields.CardNumber)}
                  maxLength={
                    selects.IDCardtype[IDCardTypeID - 1] && selects.IDCardtype[IDCardTypeID - 1].ID === 6
                      ? undefined
                      : fields.CardNumber && fields.CardNumber.MaxLen
                  }
                  minLength={fields.CardNumber.MinLen}
                  normalize={normalizeCardNumber(
                    'IDCardTypeID',
                    fields.CardNumber.NumField,
                    selects.IDCardtype[IDCardTypeID - 1] && selects.IDCardtype[IDCardTypeID - 1].ID,
                  )}
                  onFocus={this.handleCardNumberAltInputFocus}
                  onCopy={handlePreventAction}
                  onCut={handlePreventAction}
                  onPaste={handlePreventAction}
                  onDrag={handlePreventAction}
                  onDrop={handlePreventAction}
                  onBlur={this.handleCardNumberInputBlur}
                  format={cardNumberFocusState === 'primary' ? this.formatHiddenValue : undefined}
                  isPersonalNo
                />
              )}
              {!!fields.OtherIDNumber && (
                <FormField
                  visible={noVisibilityFilter || !!fields.OtherIDNumber}
                  name="OtherIDNumberAlt"
                  required={isRequired(fields.OtherIDNumber)}
                  type="text"
                  onFocus={this.handleOtherIDNumberAltInputFocus}
                  onCopy={handlePreventAction}
                  onCut={handlePreventAction}
                  onPaste={handlePreventAction}
                  onDrag={handlePreventAction}
                  onDrop={handlePreventAction}
                  onBlur={this.handleOtherIDNumberInputBlur}
                  format={otherIDNumberFocusState === 'primary' ? this.formatHiddenValue : undefined}
                  maxLength={fields.OtherIDNumber ? fields.OtherIDNumber.MaxLen : -1}
                  labelFieldProportions="5:11"
                />
              )}
            </FormLayout>
          )}

          {(!!fields.IDCardRegDate || !!fields.IDValidityDate) && (
            <FormLayout
              visible={noVisibilityFilter || !!(fields.IDCardRegDate || fields.IDValidityDate)}
              label={translate('lbl_id_card_issue_date')}
              fieldProportions="7:1:8"
              labelFieldProportions="5:11"
            >
              {!!fields.IDCardRegDate && (
                <StyledDatePicker
                  visible={noVisibilityFilter || !!fields.IDCardRegDate}
                  name="IDCardRegDate"
                  type="date"
                  upward
                  required={isRequired(fields.IDCardRegDate)}
                />
              )}

              {fields.IDValidityDate ? (
                <Checkbox
                  disabled={isRequired(fields.IDValidityDate)}
                  checked={ShowIDValidityDate}
                  onChange={this.handleShowIDValidityDateChange}
                />
              ) : (
                <span />
              )}

              {!!fields.IDValidityDate && (
                <StyledDatePicker
                  visible={noVisibilityFilter || !!fields.IDValidityDate}
                  name="IDValidityDate"
                  type="date"
                  upward
                  required={isRequired(fields.IDValidityDate)}
                />
              )}
            </FormLayout>
          )}

          {!!fields.IND_Sex && (
            <FormLayout
              visible={noVisibilityFilter || !!fields.IND_Sex}
              label={translate('lbl_sex_t')}
              labelFieldProportions="5:11"
            >
              <FormField
                name="IND_Sex"
                options={selects.Gender}
                required={isRequired(fields.IND_Sex)}
                type="select"
                search
              />

              <LKButton alias="info" style={{ width: '100%' }}>
                Doc Status
              </LKButton>
            </FormLayout>
          )}

          <GridContainer smallPadding>
            <Grid>
              <Grid.Row verticalAlign="middle" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Grid.Column width={11} style={{ padding: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{ width: '50%', textAlign: 'right' }}>
                      <LKDropdownButton
                        name="Request CRA"
                        containerStyle={{ width: '100%' }}
                        style={{ width: '100%' }}
                        options={craConfig.map((item) => {
                          const key = Object.keys(item)[0]
                          return {
                            text: key,
                            value: item[key],
                            onClick: this.handleCRAOptionChange,
                          }
                        })}
                        alias="info"
                        size="tiny"
                        upward
                        fluid
                      />
                    </div>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </div>
        {/* <div style={{ width: '30%', padding: 25 }}>
          <img src={CRAImage} style={{ width: '100%' }} alt="cra" />
        </div> */}
      </div>
    )
  }
}

export default container(IdentityInformation)
